let baseURL = process.env.VUE_APP_baseURL;
let jiuRuiApi = process.env.VUE_APP_API_JIURUI;
let jumpWeb = process.env.VUE_APP_fileURL;
let fileURL = process.env.VUE_APP_jumpWeb;
let testURL = process.env.VUE_APP_testURL;
let testApiURL = process.env.VUE_APP_testApiURL;
let sysId = process.env.VUE_APP_sysId;
let leafletApiURL = process.env.VUE_APP_leafletApiURL;
let leafletApiURLV3 = process.env.VUE_APP_leafletApiURLV3;
let leafletSysId = process.env.VUE_APP_leafletSysId;
let videourl = process.env.VUE_APP_videourl;
let webUrl = process.env.VUE_APP_webUrl;
let xueKeKnowledgeBase = process.env.VUE_APP_xueKeKnowledgeBase;
let salt = "read-crtvup*123.cv987@"; //征订md5加密盐值
let publicKey = process.env.VUE_APP_publicKey; //征订token加密私钥
let robotBook = [
  "1694952726309507072",
  "1674758026424356864",
  "1686915284222480384",
  "1613418196050776064",
  "1715350359456747520",
  "1689873142887092224",
  "1714910845827420160",
  "1714911020151083008",
  "1714915177180303360",
  "1714915363659059200",
  "1714915523055194112",
  "1714915696862957568",
  "1714915891730321408",
  "1714916095212785664",
  "1714916282954027008",
  "1714918148932767744",
  "1734864214557855744",
  "1905266919196463104",
];
module.exports = {
  baseURL,
  jiuRuiApi,
  jumpWeb,
  fileURL,
  testURL,
  testApiURL,
  sysId,
  leafletApiURL,
  leafletApiURLV3,
  leafletSysId,
  salt,
  videourl,
  robotBook,
  webUrl,
  xueKeKnowledgeBase,
  publicKey,
};
